<template>

    <div 
        v-if="!fileData.fileCDN && !fileData.uploading" 
        class="upload-file-drag"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
    >
        <i class="material-icons-outlined">cloud_upload</i>
        <span>{{ $t('uploadFileDrag.DRAG_DROP_OR_CLICK') }}</span>
        <label for="uploadFile">
            <span>{{ $t('uploadFileDrag.UPLOAD_FILE') }}</span>
            <input type="file" accept="image/png" name="uploadFile" id="uploadFile" @change="addFile($event)">
        </label>
        <slot /> 
    </div>

    <div v-if="fileData.uploading" class="uploading">
        <i class="material-icons-outlined">cloud_upload</i>
        <span>{{ $t('uploadFileDrag.UPLOADING_FILE') }}</span>
    </div>

    <div v-if="fileData.fileCDN">
        <span style="font-size: 12px; font-weight: 700; align-self: flex-start;">{{ $t('uploadFileDrag.UPLOADED_FILES') }}</span>
        <div class="fileUploaded">
        <div class="fileUploaded_data">
            <i class="material-icons-outlined">image</i>
            <span class="fileUploaded_file">
                <!-- <a v-if="props.currentFile" :href="props.currentFile" target="_blank" style="cursor: pointer;">1 archivo subido</a> -->
                <a :href="fileData.fileCDN" target="_blank" style="cursor: pointer;">{{ fileData.fileName || $t('uploadFileDrag.ONE_FILE_UPLOADED') }}</a>
                {{ fileData.fileSize ? `${ fileData.fileSize} KB` : ''}} 
            </span>
        </div>
        <i @click="deleteFile()" class="material-icons-outlined">close</i>
        </div>
    </div>

</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import storage from "@/plugins/azure-storage";
import { useI18n } from 'vue-i18n';

// eslint-disable-next-line
const { t } = useI18n();



const emit = defineEmits(['fileUploaded', 'fileDeleted']);
const props = defineProps({
    currentFile: String,
    containerCDN: String,
})

const fileData = ref({
    file: '',
    fileName: '',
    fileSize: '',
    fileCDN: props.currentFile || '',
    uploading: false
})

const isDraggin = ref(false);

const uploadFileCDN = async() => {
    fileData.value.uploading = true;
    let fileCDN = await storage.updateFile(fileData.value.file, props.containerCDN);
    let blobPath = process.env.VUE_APP_CDN_URL;
    if(process.env.VUE_APP_STORAGE_MODE == 'ps-storage'){
        blobPath = process.env.VUE_APP_PSSTORAGE_URL;
    }
    fileData.value.fileCDN = `${blobPath}contentresources/${fileCDN}`;
    fileData.value.uploading = false;

    emit('fileUploaded',fileData.value.fileCDN);
}

const dragover = (e) => {
    e.preventDefault();
    isDraggin.value = true;
}

const dragleave = (e) => {
    e.preventDefault();
    isDraggin.value = false;
}

const drop = async(e) => {
    e.preventDefault();
    fileData.value.fileName = e.dataTransfer.files[0].name;
    fileData.value.fileSize = Math.round(e.dataTransfer.files[0].size / 1024);
    fileData.value.file = e.dataTransfer.files[0];
    isDraggin.value = false;
    uploadFileCDN();
}

const addFile = async(e) => {
    fileData.value.fileName = e.target.files[0].name;
    fileData.value.fileSize = Math.round(e.target.files[0].size / 1024);
    fileData.value.file = e.target.files[0];
    uploadFileCDN();
}

const deleteFile = () => {
    fileData.value.file = '';
    fileData.value.fileName = '';
    fileData.value.fileSize = '';
    fileData.value.fileCDN = '';
    emit('fileDeleted');
}




</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.upload-file-drag, .uploading{
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f6f6f6;
    align-items: center;
    padding: 27px 0;
    border-radius: 10px;
    font-size: 13px;
    gap: 6px;
    .material-icons-outlined{
      padding: 12px;
      border-radius: 99px;
      color: #fff;
      background-color: $green;
      //margin-bottom: 12px;
    }
    label{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $green;
      cursor: pointer;
      font-weight: 600;
      input{
        display: none;
      }
    }
}

.uploading{
    color: $green;
    font-weight: 600;
}


.fileUploaded{
    width: fit-content;
    padding: 26px 28px;
    margin-top: 6px;
    display: flex;
    align-items: flex-start;
    gap: 20px;
    background-color: #F6F6F6;
    &_data{
        display: flex;
        align-items: flex-start;
        gap: 12px;
        .material-icons-outlined:first-child{
            font-size: 28px;
        }
    }
    &_file{
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-weight: 400;
        font-size: 15px;
        font-weight: 600;
        a{
            display: block;
            max-width: 180px;
            text-decoration: none;
            color: $green;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
        }
    }
    .material-icons-outlined:last-child{
        cursor: pointer;
    }
}


.disabled{
    opacity: .3;
    pointer-events: none;
}



</style>

